import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideCollectiviteStub } from '../../../../config/aides-collectivites';

export default function OptimisationTurpePage() {
  const aide = getAideCollectiviteStub('optimisation-turpe');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="collectivites" />;
}
